export default __webpack_public_path__ + "static/media/paymentfailed-man-mobile.53f57903.webp";